import React, { Component } from 'react'
import HttpServices from '../../utils/Http.services'
import { translate } from '../../utils/useful'
import FormViewer from '../FormViewer'
import LoaderButton from '../LoaderButton'
export default class ThirdStep extends Component {
    state = {
        headers: [

            // { key: 'Available', type: 'NumberInput', col: '12', information: { label: '{{lang}}Available number', placeholder: '{{lang}}Write down the number of availablity', required: false } },
            { key: 'price', type: 'PriceInput', col: '6', information: { label: '{{lang}}Price', placeholder: '{{lang}}Sales Price', required: true } },
            { key: 'priceSettings.discount.value', type: 'NumberInput', col: '6', information: { label: '{{lang}}Discount (%)', placeholder: '{{lang}}Discount', required: false } },

            // { key: 'category', type: 'SelectInput', col: '4', information: { label: '{{lang}}Select category', items: [{ value: 'men', title: 'men' }, { value: 'women', title: 'women' }], type: 'local', placeholder: '{{lang}}Search the Category', required: false } },
            // { key: 'values.phone', type: 'NumberInput', col: '6', information: { label: '{{lang}}Phone', placeholder: '{{lang}}Phone', required: true }, showMain: false },
            // { key: 'values.message', type: 'TextAreaInput', col: '12', information: { label: '{{lang}}Message', placeholder: '{{lang}}Write your Message.....', required: false }, showMain: false },

        ],
    }
    handleBackStep = () => {
        this.props.changePage('secondStep', 1)
    }
    nextPage = () => {
        let data = this.form.getForm()
        console.log(data)
        this.setState({ isLoading: true })
        if (data) {
            this.props.setData(data, (result, err) => {
                this.props.postInformation((result, err) => {
                    this.setState({ isLoading: false })

                })
            })
        }
    }

    render() {
        return (
            <div className='flexcc w-100'>
                <div className='w-100' style={{ maxWidth: 700 }}>
                    <FormViewer ref={el => this.form = el} headers={this.state.headers} theme={"modern"} inputClass={"modern-input"} />
                    <LoaderButton
                        onClick={this.nextPage}
                        isLoading={this.state.isLoading}
                        // text={translate('send')}
                        text='Submit'
                        type={"Oval"}
                        className="mt-4 mb-3"
                        buttonStyle={{ outline: 'none', backgroundColor: '#252525', cursor: 'pointer', padding: '10px 50px', borderRadius: 50, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                        width={40}
                        height={40}
                        color={'#fff'}
                    />
                    <div className='flexcc'>
                        {this.state.isLoading && (
                            <p className='mt-1 opacity-animation' >{translate("Please Wait, We are Uploading Images ...")}</p>
                        )}

                        {!this.state.isLoading && (

                            <button className='mt-1 opacity-5' onClick={() => this.handleBackStep()}>
                                <p>{translate('Back')}</p>
                            </button>
                        )}
                    </div>
                    {/* <LoaderButton
                        onClick={this.handleBackStep}
                        // isLoading={this.state.isLoading}
                        // text={translate('send')}
                        text='Back'
                        type={"Oval"}
                        className="mt-4 mb-3"
                        buttonStyle={{ outline: 'none', backgroundColor: '#252525', cursor: 'pointer', padding: '10px 50px', borderRadius: 50, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
                        width={40}
                        height={40}
                        color={'#fff'}
                    /> */}
                </div>
            </div>
        )
    }
}
